<template>
    <div>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" :title="dataEvent.title" :hide-footer="true" v-model="dataShow">
            <Request
                    ref="request"
                    method="PUT"
                    :onRequestSuccess="onRequestSuccess"
                    root="/event-calendar-panel/add-bookings">
                <slot slot="body">
                    <b-row>
                        <b-col>
                            <b-button @click="onBackClick" class="btn btn-sm btn-light mb-3"><i class="fa fa-chevron-left mr-2"></i> {{Core.Definition.getDefinition('Retour')}}</b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <table class="table table-no-border">
                                <tbody>
                                <tr>
                                    <td>
                                        <strong>{{Core.Definition.getDefinition('Début')}}:</strong> {{Core.Date.readableDate(dataEvent.start, 'DD MMM Y - HH:mm')}}
                                    </td>
                                    <td>
                                        <strong>{{Core.Definition.getDefinition('Fin')}}:</strong> {{Core.Date.readableDate(dataEvent.end, 'DD MMM Y - HH:mm')}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>
                    <hr/>
                    <MultipleUserBooking ref="multipleUserBooking" :displayEventDateOptions="false"></MultipleUserBooking>
                    <b-row>
                        <b-col class="text-right">
                            <b-button @click="onSaveClick" class="btn btn-success">{{Core.Definition.getDefinition('Enregistrer')}}</b-button>
                        </b-col>
                    </b-row>
                </slot>
            </Request>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import MultipleUserBooking from './MultipleUserBooking'
    import Alert from './Alert'
    import Request from './Request'
    export default {
        name: 'ModalEventDateAddBooking',
        components: {
            MultipleUserBooking,
            Request
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        root: {
                            save: '/event-date',
                            get: '/event-date',
                        },
                        displayActions: false
                    }
                }
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            event: {
                set(event) {
                    this.dataEvent = event
                },
                get() {
                    return this.dataEvent
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataShow: false,
                dataEvent: {}
            }
        },
        methods: {
            onBackClick() {
              this.$emit('onBackClick')
            },
            onSaveClick(){
                let userBookings = this.$refs.multipleUserBooking.userBookings
                userBookings = Core.Array.newArray(userBookings)
                this.$refs.request.clearArgs()
                this.$refs.request.addArg('eventDateId', this.dataEvent.id)
                this.$refs.request.addArg('userBookings', Core.Value.decode(userBookings, Core.Value.typeUserBookings))
                this.$refs.request.request()
            },
            onRequestSuccess(data, method) {
                this.$refs.multipleUserBooking.userBookings = []
                this.$emit('onBackClick')
            }
        }
    }
</script>
